import styled from 'styled-components';

export const SignedContractStepWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  gap: 32px;
  color: ${({ theme }) => theme.colors.black9};
  font-size: 14px;
  line-height: 20px;
  overflow-y: auto;

  @media (max-width: ${({ theme }) => theme.mediaQueries.sm}) {
    max-height: 60vh;
  }

  @media (min-width: ${({ theme }) => theme.mediaQueries.sm}) {
    height: 70vh;
  }
`;
